"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = require("react");

var React = _interopRequireWildcard(_react);

var _reactBootstrap = require("react-bootstrap");

var _reactIntl = require("react-intl");

var _tcombForm = require("tcomb-form");

var _tcombForm2 = _interopRequireDefault(_tcombForm);

var _connectAAARefetch = require("../../../decorators/connectAAARefetch");

var _StatusWrapper = require("../../../components/StatusWrapper");

var _StatusWrapper2 = _interopRequireDefault(_StatusWrapper);

var _API = require("../../API");

var _reactRedux = require("react-redux");

var _TCombFormWrapper = require("../../../components/TCombFormWrapper");

var _TCombFormWrapper2 = _interopRequireDefault(_TCombFormWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
    var c = arguments.length,
        r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
        d;
    if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
        if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    }return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Form = _tcombForm2.default.form.Form;

function getFormSchema() {
    return _tcombForm2.default.struct({
        name: _tcombForm2.default.String,
        client: _tcombForm2.default.maybe(_tcombForm2.default.String),
        clientFreeText: _tcombForm2.default.maybe(_tcombForm2.default.String),
        uid: _tcombForm2.default.String
    });
}
var getSchemaOptions = function getSchemaOptions(reportDefinitions, clients) {
    return {
        fields: {
            name: {
                label: React.createElement(_reactIntl.FormattedMessage, { id: "reportList.report.name" }),
                error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportList.report.name.validationError" })),
                attrs: {
                    autoFocus: true
                }
            },
            client: {
                label: "Bestehender Kunde",
                options: clients.map(function (client) {
                    return {
                        value: client.id,
                        text: client.name
                    };
                }),
                factory: _tcombForm2.default.form.Select
            },
            clientFreeText: {
                label: "Neuer Kunde"
            },
            uid: {
                label: React.createElement(_reactIntl.FormattedMessage, { id: "reportList.new.modal.reportType.title" }),
                error: React.createElement("i", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportList.new.modal.reportType.title.validationError" })),
                options: reportDefinitions.map(function (definition) {
                    return {
                        value: definition.uid,
                        text: definition.title
                    };
                }),
                factory: _tcombForm2.default.form.Select
            }
        }
    };
};
var ReportNewModal = function (_React$Component) {
    _inherits(ReportNewModal, _React$Component);

    function ReportNewModal(props) {
        _classCallCheck(this, ReportNewModal);

        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ReportNewModal).call(this, props));

        _this.isLoading = false;
        _this.onHide = function (e) {
            _this.props.onClose();
        };
        _this.onFormChange = function (data) {
            _this.setState({
                currentFormData: data
            });
        };
        _this.onFormSubmit = function (e) {
            e.preventDefault();
            var tempRefs = _this.refs;
            var data = tempRefs.form.getValue();
            if (data) {
                // XXX replace with proper validation? hekker 20180429
                if (!data.client && !data.clientFreeText) {
                    alert("Eines von Bestehender Kunde oder Neuer Kunde Feld muss einen Wert haben");
                } else if (data.client && data.clientFreeText) {
                    alert("Nur eines von Bestehender Kunde und Neuer Kunde Feld darf einen Wert haben");
                } else {
                    _this.isLoading = true;
                    _this.props.createReport(data.name, data.client, data.clientFreeText, data.uid);
                }
            }
        };
        _this.isLoading = false;
        _this.state = {
            currentFormData: null
        };
        return _this;
    }

    _createClass(ReportNewModal, [{
        key: "render",
        value: function render() {
            var _props = this.props;
            var createReportFetch = _props.createReportFetch;
            var createReport = _props.createReport;
            var formatMessage = this.props.intl.formatMessage;

            var title = formatMessage({ id: "reportList.new.modal.title" });
            if (this.props.reports.reportDefinitions) {
                var schema = getFormSchema();
                var schemaOptions = getSchemaOptions(this.props.reports.latestReportDefinitions, this.props.clients);
                return React.createElement(_reactBootstrap.Modal, { show: this.props.showModal, onHide: this.onHide, enforceFocus: false }, React.createElement(_StatusWrapper2.default, { isLoading: createReportFetch.loading, error: createReportFetch.error, onDismissError: createReportFetch.dismissError }, React.createElement(_reactBootstrap.Modal.Header, { closeButton: true }, React.createElement(_reactBootstrap.Modal.Title, null, title)), React.createElement(_reactBootstrap.Modal.Body, null, React.createElement("p", null, React.createElement(_reactIntl.FormattedMessage, { id: "reportList.new.modal.description" })), React.createElement(_TCombFormWrapper2.default, { onSubmit: this.onFormSubmit, ref: "form", type: schema, options: schemaOptions, value: this.state.currentFormData, onChange: this.onFormChange })), React.createElement(_reactBootstrap.Modal.Footer, null, React.createElement(_reactBootstrap.Row, null, React.createElement(_reactBootstrap.Col, { xs: 12 }, React.createElement(_reactBootstrap.ButtonGroup, null, React.createElement(_reactBootstrap.Button, { bsStyle: "primary", onClick: this.onFormSubmit, disabled: this.isLoading }, React.createElement("i", { className: "fa fa-plus" }), " ", React.createElement(_reactIntl.FormattedMessage, { id: "reportList.new.modal.title" }))))))));
            }
            return null;
        }
    }]);

    return ReportNewModal;
}(React.Component);
ReportNewModal = __decorate([_reactIntl.injectIntl, (0, _reactRedux.connect)(function (state) {
    return {
        reports: state.reports
    };
}), (0, _connectAAARefetch.connectAAARefetch)(function (props) {
    return {
        createReportFetch: { value: null },
        createReport: function createReport(name, _client, clientFreeText, definitionUid) {
            return {
                createReportFetch: Object.assign(_API.client.buildRefetchOptions(_API.API.createReport(name, _client, clientFreeText, definitionUid)), {
                    then: function then(value) {
                        props.onSuccess(value.uid, definitionUid);
                    }
                })
            };
        }
    };
})], ReportNewModal);
exports.default = ReportNewModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/containers/reports/ReportNewModal.tsx
 ** module id = 1287
 ** module chunks = 0
 **/